import { Component, Input, OnInit, input } from '@angular/core';
import { NzRateModule } from 'ng-zorro-antd/rate';
import { FormsModule } from '@angular/forms';

@Component({
    selector: 'app-skills',
    templateUrl: './skills.component.html',
    styleUrl: './skills.component.scss',
    imports: [NzRateModule, FormsModule]
})
export class SkillsComponent implements OnInit {
	@Input() skills: any;
	@Input() AIskills: any;
	readonly settings = input<any>();
	readonly aiSettings = input<any>();

	public isSkillNameView: boolean;
	public isProficiencyView: boolean;
	public isYearsExpView: boolean;

	public isAiSkillNameView: boolean;
	public isAiProficiencyView: boolean;
	public isAiYearsExpView: boolean;
	public isAiDescriptionView: boolean;

	ngOnInit(): void {
		this.isSkillNameView = this.settings()
			?.filter((e: any) => e.name == 'Skill Name')
			.map((e: any) => e.active)[0];
		const settings = this.settings();
  this.isProficiencyView = settings
			?.filter((e: any) => e.name == 'Proficiency')
			.map((e: any) => e.active)[0];
		this.isYearsExpView = settings
			?.filter((e: any) => e.name == 'Years of Experience')
			.map((e: any) => e.active)[0];

		const aiSettings = this.aiSettings();
		this.isAiSkillNameView = aiSettings
			?.filter((e: any) => e.name == 'Skill Name')
			.map((e: any) => e.active)[0] ?? false;
		this.isAiProficiencyView = aiSettings
			?.filter((e: any) => e.name == 'Proficiency')
			.map((e: any) => e.active)[0] ?? false;
		this.isAiYearsExpView = aiSettings
			?.filter((e: any) => e.name == 'Years of Experience')
			.map((e: any) => e.active)[0] ?? false;
		this.isAiDescriptionView = aiSettings
			?.filter((e: any) => e.name == 'Description')
			.map((e: any) => e.active)[0] ?? false;
	}
}
